module.exports = __webpack_public_path__ + "static/media/211CS229.33c31be2.png";